/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { BatchPostRequest } from '../models/BatchPostRequest';
import type { ChargebackQuery } from '../models/ChargebackQuery';
import type { PagedItems } from '../models/PagedItems';
import type { PagingQuery } from '../models/PagingQuery';
import type { TransactionBulkCreate } from '../models/TransactionBulkCreate';
import type { TransactionCreate } from '../models/TransactionCreate';
import type { TransactionDetails } from '../models/TransactionDetails';
import type { TransactionRefundCreate } from '../models/TransactionRefundCreate';
import type { TransactionRefundDetails } from '../models/TransactionRefundDetails';
import type { TransactionVoidCreate } from '../models/TransactionVoidCreate';
import type { TransactionVoidDetails } from '../models/TransactionVoidDetails';
import { request as __request } from '../core/request';

export class TransactionsVService {

    /**
     * @param requestBody
     * @returns PagedItems OK
     * @throws ApiError
     */
    public static async transactionsVGetAll(
        requestBody?: PagingQuery,
    ): Promise<PagedItems> {
        const result = await __request({
            method: 'POST',
            path: `/api/v2/transactions/get`,
            body: requestBody,
            errors: {
                400: `Bad Request`,
                401: `Unauthorized`,
            },
        });
        return result.body;
    }

    /**
     * @param requestBody
     * @returns TransactionDetails OK
     * @throws ApiError
     */
    public static async transactionsVGetExport(
        requestBody?: PagingQuery,
    ): Promise<TransactionDetails> {
        const result = await __request({
            method: 'POST',
            path: `/api/v2/transactions/export`,
            body: requestBody,
            errors: {
                401: `Unauthorized`,
                403: `Forbidden`,
            },
        });
        return result.body;
    }

    /**
     * @param transactionId
     * @returns TransactionDetails OK
     * @throws ApiError
     */
    public static async transactionsVGetById(
        transactionId: string,
    ): Promise<TransactionDetails> {
        const result = await __request({
            method: 'GET',
            path: `/api/v2/transactions/${transactionId}`,
            errors: {
                401: `Unauthorized`,
                404: `Not Found`,
            },
        });
        return result.body;
    }

    /**
     * @param transactionId
     * @param requestBody
     * @returns TransactionDetails OK
     * @throws ApiError
     */
    public static async transactionsVUpdate(
        transactionId: string,
        requestBody?: BatchPostRequest,
    ): Promise<TransactionDetails> {
        const result = await __request({
            method: 'PATCH',
            path: `/api/v2/transactions/${transactionId}`,
            body: requestBody,
        });
        return result.body;
    }

    /**
     * @param transactionId
     * @param requestBody
     * @returns TransactionVoidDetails OK
     * @throws ApiError
     */
    public static async transactionsVVoid(
        transactionId: string,
        requestBody?: TransactionVoidCreate,
    ): Promise<TransactionVoidDetails> {
        const result = await __request({
            method: 'POST',
            path: `/api/v2/transactions/${transactionId}/void`,
            body: requestBody,
            errors: {
                400: `Bad Request`,
                401: `Unauthorized`,
                500: `Internal Server Error`,
            },
        });
        return result.body;
    }

    /**
     * @param transactionId
     * @param requestBody
     * @returns TransactionRefundDetails OK
     * @throws ApiError
     */
    public static async transactionsVRefund(
        transactionId: string,
        requestBody?: TransactionRefundCreate,
    ): Promise<TransactionRefundDetails> {
        const result = await __request({
            method: 'POST',
            path: `/api/v2/transactions/${transactionId}/refund`,
            body: requestBody,
            errors: {
                400: `Bad Request`,
                401: `Unauthorized`,
                500: `Internal Server Error`,
            },
        });
        return result.body;
    }

    /**
     * @param requestBody
     * @returns TransactionDetails Created
     * @throws ApiError
     */
    public static async transactionsVCreate(
        requestBody?: TransactionCreate,
    ): Promise<TransactionDetails> {
        const result = await __request({
            method: 'POST',
            path: `/api/v2/transactions`,
            body: requestBody,
            errors: {
                400: `Bad Request`,
                401: `Unauthorized`,
                500: `Internal Server Error`,
            },
        });
        return result.body;
    }

    /**
     * @param requestBody
     * @returns TransactionDetails Created
     * @throws ApiError
     */
    public static async transactionsVCreateBulk(
        requestBody?: Array<TransactionBulkCreate>,
    ): Promise<Array<TransactionDetails>> {
        const result = await __request({
            method: 'POST',
            path: `/api/v2/transactions/bulk`,
            body: requestBody,
        });
        return result.body;
    }

    /**
     * @param requestBody
     * @returns TransactionDetails OK
     * @throws ApiError
     */
    public static async transactionsVGetAllForChargebacks(
        requestBody?: Array<ChargebackQuery>,
    ): Promise<Array<TransactionDetails>> {
        const result = await __request({
            method: 'POST',
            path: `/api/v2/transactions/get/chargebacks`,
            body: requestBody,
        });
        return result.body;
    }

    /**
     * @param requestBody
     * @returns any No Content
     * @throws ApiError
     */
    public static async transactionsVDeleteRecords(
        requestBody?: Array<string>,
    ): Promise<any> {
        const result = await __request({
            method: 'POST',
            path: `/api/v2/transactions/delete`,
            body: requestBody,
        });
        return result.body;
    }

    /**
     * @param requestBody
     * @returns TransactionDetails OK
     * @throws ApiError
     */
    public static async transactionsVGetAllTransactions(
        requestBody?: Array<string>,
    ): Promise<Array<TransactionDetails>> {
        const result = await __request({
            method: 'POST',
            path: `/api/v2/transactions/get/all`,
            body: requestBody,
        });
        return result.body;
    }

}